export const plCommonTranslations = {
    now: 'Teraz',
};

export const enCommonTranslations = {
    now: 'Now',
};
